import React from 'react';
import { ServiceType } from '../types';

interface ServiceCardProps {
  service: ServiceType;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service }) => {
  return (
    <div className="p-6 border border-[#E5E5E5] rounded-2xl hover:shadow-lg transition-shadow duration-300 bg-white flex flex-col justify-between">
      <h3 className="text-lg font-medium mb-3 text-[#7A6E62]">{service.name}</h3>
      <div className="flex justify-between items-center mt-auto">
        <span className="text-lg font-semibold text-[#C7B9A5]">{service.price}</span>
        <span className="text-sm text-gray-400 capitalize">{service.category}</span>
      </div>
    </div>
  );
};

export default ServiceCard;
